import React, { useEffect } from 'react';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { useI18n } from '../../../../i18n';
import { DragItemType } from '../dnd/DragItemType';
import ActionBar from '../../general/actionbar/ActionBar';
import icon from '../../../img/icons/trash.png';
import { className, fromProps } from '../../../lib/className';

/**
 * @param {Object} props
 * @param {string} [props.title]
 * @param {boolean} [props.disabled]
 */

function ActionRemove(props) {
	const { f } = useI18n();

	const [{ isDragging }, dragRef, dragPreview] = useDrag({
		item: { type: DragItemType.ACTION_REMOVE },
		canDrag: () => !props.disabled,
		collect: monitor => ({
			isDragging: monitor.isDragging()
		})
	});

	useEffect(() => {
		dragPreview(getEmptyImage(), { captureDraggingState: true });
	}, []);

	return (
		<ActionBar.Action
			className={className('drag', 'remove', fromProps(props), { 'draggable': isDragging })}
			customRef={dragRef}
			disabled={props.disabled}
			title={props.title || f('delete')}
		>
			<img src={icon} alt="" />
		</ActionBar.Action>
	)
}

export default ActionRemove;
